import {clearObject} from './common';
import funParabola from './parabola';

var expObj = {};
export default expObj;


// 开始添加menu特性.


var countOffset = function(event){
	var target = event;
	var offsetTop = 0,//parseInt(event.offsetHeight/2),
			offsetLeft = parseInt(event.offsetWidth/2);
	while(target){
		offsetTop += target.offsetTop;
		if(target.scrollTop>0){
			offsetTop -= target.scrollTop;
		}
		offsetLeft += target.offsetLeft;
		target = target.offsetParent;
	}
	return {x:offsetLeft,y:offsetTop};
}

var fylTimer;
var myParabola;
expObj.flyNum = function(fromEvent,toEvent){
	var fromEventOffset = countOffset(fromEvent);
	var rootChildren = window.document.body.children;
	var flyNumEvent;
	for(var i=0,l=rootChildren.length;i<l;i++){
		if(rootChildren[i].getAttribute("id") == 'flyNumBox'){
			flyNumEvent = rootChildren[i];
			break;
		}
	}
	if(!flyNumEvent){
		flyNumEvent = document.createElement("span");
		flyNumEvent.setAttribute("id","flyNumBox");
		window.document.body.appendChild(flyNumEvent);
	}

	//初始位置
	flyNumEvent.style="left:"+fromEventOffset.x+"px;top:"+fromEventOffset.y+"px";
	
	//return ;

	// 初始化抛物线动画
	//if(isFlying){return;}
	if(!myParabola){
		myParabola = funParabola(flyNumEvent, toEvent, {
			speed: 600,// 每帧移动的像素大小
			curvature: 0.006,// 实际指焦点到准线的距离
			complete: function () {
				flyNumEvent.style.visibility = "hidden";
			}
		});
	}
	
	myParabola.position().move();
}
export const flyNum = expObj.flyNum ;


/**
 * 检查餐品灰属性
 * @param {*} pro 要检查的餐品
 * @return {status,msg,errorCode}
 */
expObj.checkProSelect = function(pro){

	if(pro.isSoldOut){
		return {status:2,msg:"抱歉,餐品已售罄",errorCode:"001"};
	}else if(pro.hasInventory && pro.inventoryNum <= pro.num){
		return {status:2,msg:"抱歉,餐品库存不足",errorCode:"002"};
	}else if(!pro.isInServiceTime){
		return {status:2,msg:"抱歉,餐品不在供应时间",errorCode:"003"};
	}
	return {status:1,msg:"",errorCode:"000"};
}
export const checkProSelect = expObj.checkProSelect ;





// WEBPACK FOOTER //
// ./../../plugins/utils/menu.js